export default function Cookies() {
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="font-heading font-bold text-section text-neutral-800 mb-8">
          Política de Cookies
        </h1>

        <div className="prose prose-neutral max-w-none">
          <p className="lead text-lg text-neutral-600 mb-6">
            Esta plataforma utiliza cookies para mejorar tu experiencia de navegación y analizar el
            uso del sitio web.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">¿Qué son las cookies?</h2>
          <p>
            Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando
            visitas un sitio web. Se utilizan para que el sitio web funcione de manera más eficiente
            y para proporcionar información a los propietarios del sitio.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            Tipos de cookies que utilizamos
          </h2>

          <h3 className="font-semibold text-lg mt-6 mb-3">1. Cookies Esenciales (No desactivables)</h3>
          <p>
            Estas cookies son necesarias para el funcionamiento básico del sitio web y no pueden ser
            desactivadas.
          </p>
          <table className="min-w-full border border-neutral-300 mt-4">
            <thead>
              <tr className="bg-neutral-100">
                <th className="border border-neutral-300 px-4 py-2">Cookie</th>
                <th className="border border-neutral-300 px-4 py-2">Finalidad</th>
                <th className="border border-neutral-300 px-4 py-2">Duración</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">session_id</td>
                <td className="border border-neutral-300 px-4 py-2">Mantener sesión de usuario</td>
                <td className="border border-neutral-300 px-4 py-2">Sesión</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">CSRF_token</td>
                <td className="border border-neutral-300 px-4 py-2">Seguridad (prevenir CSRF)</td>
                <td className="border border-neutral-300 px-4 py-2">Sesión</td>
              </tr>
            </tbody>
          </table>

          <h3 className="font-semibold text-lg mt-6 mb-3">2. Cookies de Preferencias</h3>
          <p>
            Estas cookies permiten que el sitio web recuerde tus preferencias (como idioma o tema).
          </p>
          <table className="min-w-full border border-neutral-300 mt-4">
            <thead>
              <tr className="bg-neutral-100">
                <th className="border border-neutral-300 px-4 py-2">Cookie</th>
                <th className="border border-neutral-300 px-4 py-2">Finalidad</th>
                <th className="border border-neutral-300 px-4 py-2">Duración</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">language</td>
                <td className="border border-neutral-300 px-4 py-2">Idioma seleccionado</td>
                <td className="border border-neutral-300 px-4 py-2">1 año</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">dark_mode</td>
                <td className="border border-neutral-300 px-4 py-2">Tema oscuro activado</td>
                <td className="border border-neutral-300 px-4 py-2">1 año</td>
              </tr>
            </tbody>
          </table>

          <h3 className="font-semibold text-lg mt-6 mb-3">3. Cookies Analíticas</h3>
          <p>
            Estas cookies nos ayudan a entender cómo los visitantes interactúan con el sitio web.
          </p>
          <table className="min-w-full border border-neutral-300 mt-4">
            <thead>
              <tr className="bg-neutral-100">
                <th className="border border-neutral-300 px-4 py-2">Cookie</th>
                <th className="border border-neutral-300 px-4 py-2">Finalidad</th>
                <th className="border border-neutral-300 px-4 py-2">Duración</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">_ga</td>
                <td className="border border-neutral-300 px-4 py-2">Google Analytics</td>
                <td className="border border-neutral-300 px-4 py-2">2 años</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">ga_id</td>
                <td className="border border-neutral-300 px-4 py-2">Estadísticas internas (anónimas)</td>
                <td className="border border-neutral-300 px-4 py-2">2 años</td>
              </tr>
            </tbody>
          </table>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            Gestión de Cookies
          </h2>
          <p>
            Puedes gestionar tus preferencias de cookies en cualquier momento desde la configuración
            de tu cuenta o desde tu navegador. Ten en cuenta que deshabilitar ciertas cookies puede
            afectar la funcionalidad del sitio web.
          </p>

          <h3 className="font-semibold text-lg mt-6 mb-3">Cómo bloquear cookies en tu navegador:</h3>
          <ul>
            <li>Chrome: Configuración &gt; Privacidad y seguridad &gt; Cookies</li>
            <li>Firefox: Opciones &gt; Privacidad y seguridad &gt; Cookies</li>
            <li>Safari: Preferencias &gt; Privacidad &gt; Cookies</li>
            <li>Edge: Configuración &gt; Privacidad y servicios &gt; Cookies</li>
          </ul>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            Más Información
          </h2>
          <p>
            Para más información sobre cookies y cómo funcionan, visita:
            <br />
            <a
              href="https://www.aepd.es/es/areas-de-actuacion/reglamento-europeo-de-proteccion-de-datos/guias-sobre-cookies"
              className="text-education hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Guía sobre cookies de la AEPD
            </a>
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            Actualizaciones
          </h2>
          <p>
            Esta política puede actualizarse periódicamente. Última actualización: Enero 2025.
          </p>
        </div>
      </div>
    </div>
  )
}
